//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  data() {
    return {
      type_name: this.$route.query.name,
      type_play_num: this.$route.query.play_num,
      list_ary: [],
      qq_media_url: "http://qq.littlewindy.com/",
      type_num: this.$route.query.id,
      music_pic: [{
        src: "zwza",
        name: "中文最爱"
      }, {
        src: "zwlx",
        name: "中文流行"
      }, {
        src: "zwjd",
        name: "中文经典"
      }, {
        src: "yyjd",
        name: "粤语经典"
      }, {
        src: "ywgq",
        name: "英文歌曲"
      }, {
        src: "zrly",
        name: "自然录音"
      }, {
        src: "qyyq",
        name: "轻音乐曲"
      }, {
        src: "zwza",
        name: "武侠之风"
      }, {
        src: "wxzf",
        name: "悟道篇章"
      }, {
        src: "yxsx",
        name: "游戏赏析"
      }, ],
      play_the_num: {
        index: "",
        src: "",
        name: "",
        state: false
      }
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    search: function() {
      this.$http.get('/music/common.php', {
          params: {
            form: 'music',
            type_num: this.type_num,
            orderByObj: "play_num",
            orderBy: "desc"
          },
        }).then((res) => {
          this.list_ary = res.data.data;
          // this.play_the_num.src = this.qq_media_url + this.list_ary[0].route;
          // this.play_the_num.name = this.list_ary[0].title;
          this.play_the_num.name = "请选择";

        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDetail(item, index) {
      console.log("item", item);
      this.play_the_num.name = item.title;
      this.play_the_num.state = true;
      this.play_the_num.index = index;
      this.$refs.myAudio.src = this.qq_media_url + item.route;
      this.$refs.myAudio.play();

      this.$http.get('/music/add_num.php', {
        params: {
          form: "music",
          id: item.id,
        }
      }).then((res) => {
        if (res.data.status == 1) {} else {
          this.$message({
            showClose: true,
            message: res.data.info,
            type: 'error'
          });
        }
      });
    },
    play_the_song() {
      if (!this.$refs.myAudio.src) {
        this.$message({
          showClose: true,
          message: '请选择',
          type: 'error'
        });
        return;
      }
      this.play_the_num.state = !this.play_the_num.state;
      this.$refs.myAudio.play();
    },
    stop_the_song() {
      this.play_the_num.state = !this.play_the_num.state;
      this.$refs.myAudio.pause()
    },
    play_the_first_song() {
      if (this.list_ary.length > 0) {
        this.getDetail(this.list_ary[0], 0);
      }
    },
    play_next() {
      if (parseInt(this.play_the_num.index) + 1 >= this.list_ary.length) {
        this.play_the_first_song();
      } else {
        this.getDetail(this.list_ary[parseInt(this.play_the_num.index) + 1], this.play_the_num.index + 1);
      }
    }

  },
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/music/music_detail.vue